import { ReactNode } from 'react';
import { IonCard } from '@ionic/react';

export interface ICardProps {
    padded?: boolean;
    onClick?: () => void;

    // TODO: migrate data-type to data-props
    'data-type'?: string;

    dataProps?: any;
    children: ReactNode
}

export const Card: React.FC<ICardProps> = ({ padded, onClick, 'data-type': dataType, children, dataProps = {} }) => {
    const style = {
        // by default, text inside a <Card> is lighter gray, unsetting this reverts it to default text color
        '--color': 'unset',

        // if clickable, show pointer
        cursor: onClick ? 'pointer' : undefined
    };

    return (
        <IonCard data-type={dataType} {...dataProps} style={style} className={padded ? 'ion-padding': undefined} onClick={onClick}>
            {children}
        </IonCard>
    );
};
